import DefaultAction from '@/app/providers/default-action'
import DesignSystemLauncher from '@/app/providers/design-system-launcher'
import SessionExpiredModal from '@/app/providers/session-expired-modal'
import SplashScreen from '@/app/providers/splash-screen/SplashScreen'
import { ProvidersContext } from '@/shared/context'
import { queryClient } from '@/shared/queries'
import { ReduxProvider } from '@/shared/redux'
import { LayoutSettingsProvider } from '@/shared/ui'
import ErrorBoundary from '@/shared/ui/boundary'
import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from 'react-router-dom'
import { GlobalThemeConfig } from './providers/theme'
import { router } from './routes'

export default function App() {
  return (
    <ErrorBoundary>
      <ReduxProvider>
        <QueryClientProvider client={queryClient}>
          <ProvidersContext>
            <LayoutSettingsProvider>
              <GlobalThemeConfig>
                <ErrorBoundary>
                  <SplashScreen />
                  <DefaultAction />
                  <RouterProvider router={router} future={{ v7_startTransition: true }} />
                  <DesignSystemLauncher />
                  <SessionExpiredModal />
                </ErrorBoundary>
              </GlobalThemeConfig>
            </LayoutSettingsProvider>
          </ProvidersContext>
        </QueryClientProvider>
      </ReduxProvider>
    </ErrorBoundary>
  )
}
